import { Directive, ElementRef, Output, EventEmitter, Optional } from '@angular/core';
import { ToastService } from "../../common/toast.service";
import { NgModel } from '@angular/forms';
import { Subject } from 'rxjs';
@Directive({
  selector: '[slabrange][ngModel]',
  host: { '(ngModelChange)': 'rangeCheck($event)' },
  inputs: ['maxvalue', 'minvalue', 'callback', 'index'],
})
export class SlabRangeDirective {
  maxvalue;
  minvalue;
  @Output('callback') callback: EventEmitter<any> = new EventEmitter();
  index;
  constructor(public _el: ElementRef) {
    this.searchNameTermStream
      .debounceTime(1000)
      // .distinctUntilChanged()
      .subscribe((event: string) => {
        if (this.maxvalue) {
          if (parseFloat(event) < parseFloat(this.maxvalue) && parseFloat(event) > parseFloat(this.minvalue)) {
          }
          else {
            this._el.nativeElement.value = null;
            this.callback.emit(this.index);

          }
        } else if (parseFloat(event) < parseFloat(this.minvalue)) {
          this._el.nativeElement.value = null;
          this.callback.emit(this.index);
        }

        this.count = 1;
        this.lastData = "";
      })
  }
  private searchNameTermStream = new Subject<string>();
  lastData;
  count = 1;
  rangeCheck(v) {

    if (v[v.length - 1] == ' ') {
      this._el.nativeElement.value = this._el.nativeElement.value.slice(0, v.length - 1);
      // this.showError['nospace'] = true;
      // redBorderFlag=true;
    }
    // else
    // this.showError['nospace'] = false;

    if (v.length) {
      let r = new RegExp(/^\d+(\.\d{0,2})?$/);
      if (!r.test(v)) {
        this._el.nativeElement.value = this._el.nativeElement.value.slice(0, v.length - 1);
        // this.showError['cspattern'] = true;
        // redBorderFlag=true;
      }
      // else
      //   this.showError['cspattern'] = false;
    }


    if (v) {
      this.count == 1 ? this.lastData = v : this.count++
      this.searchNameTermStream.next(v);
    }
    // event=event.slice(4,event.length);
  }
}



@Directive({
  selector: '[onlynumber][ngModel]',
  host: {
    '(ngModelChange)': 'OnlyNumber($event)',
    '(keydown)': 'preventInvalidKey($event)',
    '(paste)': 'preventInvalidPaste($event)'
  },
})
export class OnlyNumber {
  constructor(public _el: ElementRef, @Optional() private ngModel: NgModel) {
  }
  preventInvalidKey(event: KeyboardEvent) {
    const allowedKeys = [
      'Backspace',
      'Delete',
      'Tab',
      'Escape',
      'Enter',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
      'Home',
      'End',
      '.'
    ];

    if (
      allowedKeys.indexOf(event.key) !== -1 ||
      event.ctrlKey ||
      event.metaKey
    ) {
      // Allow only one decimal point
      if (event.key === '.' && this._el.nativeElement.value.includes('.')) {
        event.preventDefault();
      }
      return;
    }

    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }
  preventInvalidPaste(event: ClipboardEvent) {
    const pastedText = event.clipboardData
      ? event.clipboardData.getData('text')
      : '';

    if (pastedText && !/^\d*\.?\d*$/.test(pastedText)) {
      event.preventDefault();
    }
  }
  OnlyNumber(v) {
    const value = (v || '').toString();
    // Allow digits and a single decimal point
    const sanitized = value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');

    if (value !== sanitized) {
      this._el.nativeElement.value = sanitized;
      if (this.ngModel && this.ngModel.control) {
        this.ngModel.control.setValue(sanitized, { emitEvent: false });
        this.ngModel.viewToModelUpdate(sanitized);
      }
    }
  }
}

@Directive({
  selector: '[numberordecimal][ngModel]',
  host: { '(ngModelChange)': 'NumberOrDecimal($event)' },
})
export class NumberOrDecimal {
  constructor(public _el: ElementRef) {
  }
  NumberOrDecimal(v) {
    if (v.length) {
      let r = new RegExp(/^\d+(\.\d{0,2})?$/);
      if (!r.test(v)) {
        this._el.nativeElement.value = this._el.nativeElement.value.slice(0, v.length - 1);
      }
      // event=event.slice(4,event.length);
    }
  }
}

@Directive({
  selector: '[checkmin][ngModel]',
  host: { '(ngModelChange)': 'CheckMin($event)' },
  inputs: ['maxvalue'],
})
export class CheckMin {
  maxvalue;
  constructor(public _el: ElementRef, private toast: ToastService) {
  }
  CheckMin(v) {
    if (v.length) {
      if (this.maxvalue != 0 && v != "") {
        if (Number(this.maxvalue) <= Number(v)) {
          this.toast.error('Max value should be greater than min value');
          this._el.nativeElement.value = this._el.nativeElement.value.slice(0, v.length - 1);
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/common/directives/slabRange.directive.ts